import { Injectable } from '@angular/core';
import { Datastore } from '@services/datastore';
import { Observable } from 'rxjs';
import { UntilDestroy } from '@ngneat/until-destroy';
import { CourseMemberAnswer } from '@models/course/member/course-member-answer.model';
import { JsonApiQueryData } from '@elearnio/angular2-jsonapi';

@UntilDestroy()
@Injectable({
  providedIn: 'root',
})
export class CourseMemberAnswerService {
  private filter: Record<string, unknown> = {};
  private customParams: Record<string, unknown> = {};

  constructor(private datastore: Datastore) {}

  public select(): CourseMemberAnswerService {
    this.filter = {};
    this.customParams = {};

    return this;
  }

  public filterByActivities(
    courseActivityIds: string[],
  ): CourseMemberAnswerService {
    this.filter.course_activity_ids = courseActivityIds;

    return this;
  }

  public filterByCourseAndMember(
    courseId: string,
    memberId: string,
  ): CourseMemberAnswerService {
    this.filter.latest_for_course_and_member = [courseId, memberId];

    return this;
  }

  public filterByCourseRepetitionAndMember(
    courseId: string,
    memberId: string,
    repetitionDate: string,
  ): CourseMemberAnswerService {
    if (repetitionDate) {
      this.filter.latest_for_course_repetition_and_member = [
        courseId,
        memberId,
        repetitionDate,
      ];

      return this;
    } else {
      return this.filterByCourseAndMember(courseId, memberId);
    }
  }

  public skipLoader(): CourseMemberAnswerService {
    this.customParams.skipLoader = '1';

    return this;
  }

  public request(): Observable<JsonApiQueryData<CourseMemberAnswer>> {
    const options: any = {
      filter: this.filter,
    };

    // Merge custom params at the top level
    if (Object.keys(this.customParams).length > 0) {
      Object.assign(options, this.customParams);
    }

    return this.datastore.findAll(CourseMemberAnswer, options);
  }
}
